import Contacts from "../../Components/Contacts/Contacts";
import "./Contact.css";

function Contact() {
	return (
		<div className="main-contact-container">
			<Contacts />
		</div>
	);
}

export default Contact;
